import instance from "@/lib/axios";
import { AuthResponse, LoginInput, RegisterInput, RegisterResponse, User } from "@/types/authTypes";
import type { Conversation } from "@/types/conversationTypes";

const SECURITY_URL = import.meta.env.VITE_AGENTIC_SECURITY_API_URL;

export const authApi = {
  login: (payload: LoginInput) => instance.post<AuthResponse>(`${SECURITY_URL}/authenticate`, payload),
  register: (payload: RegisterInput) => instance.post<RegisterResponse>(`${SECURITY_URL}/register`, payload),
  confirmEmail: (token: string) => instance.post(`${SECURITY_URL}/confirm-email`, { token }),
  resendConfirmation: (email: string) => instance.post(`${SECURITY_URL}/resend-confirmation`, { email }),
  forgotPassword: (email: string) => instance.post<{ message: string }>(`${SECURITY_URL}/reset-password`, { email }),
  resetPassword: (data: { email: string; resetToken: string; newPassword: string }) =>
    instance.post<{ message: string }>(`${SECURITY_URL}/reset-password`, data),
  updateUser: (userId: string, data: Partial<Pick<User, "emailAddress" | "firstName" | "lastName" | "avatarUrl">>) =>
    instance.patch<{ message: string; user: User }>(`${SECURITY_URL}/users/${userId}`, data),
  deleteUser: (userId: string) =>
    instance.delete<{ message: string }>(`${SECURITY_URL}/users/${userId}`),
  deleteConversations: (userId: string, password: string) =>
    instance.delete<{ message: string }>(`${SECURITY_URL}/users/${userId}/conversations`, { data: { password } }),
  getUserConversations: (userId: string) =>
    instance.get<Conversation[]>(`${SECURITY_URL}/users/${userId}/history`),
  getUserActiveConversation: (userId: string) =>
    instance.get<Conversation | null>(`${SECURITY_URL}/users/${userId}/active-conversation`),
  attachConversationToUser: (conversationId: string, userId: string) =>
    instance.post<{ message: string }>(`${SECURITY_URL}/users/${userId}/attach-conversation`, { conversationId }),
};
